import { useParams } from 'react-router-dom'

import useSeatmapStore from '../../../../stores/seatmapStore'

import {
  formatOfferListPrice,
  getAccessibleLabel,
  getSeatAdditionalLabel,
  getSinglarOrPluralWord,
  getValidQuantitiesForTicketGroup,
} from '../../../../utilities/helpers'

import Form from 'react-bootstrap/Form'

import ViewSwiper from '../ViewSwiper/ViewSwiper'
import { SheetTop } from '../SheetTop'
// import { AddSubtractQuantity } from "../AddSubtractQuantity";

import './ticketDetails.scss'

export default function TicketDetails({
  toggleView,
  selectedObject,
  eventTicketLimit,
  changeQuickpickQuantity,
  allowTicketCountChange = false,
}) {
  const seatmapData = useSeatmapStore((state) => state.data)
  const getIconClass = (selectedObject) => {
    if (selectedObject?.accessible) return 'accessible'
    if (selectedObject?.GA) return 'ticket'
    return 'seat'
  }

  const iconClass = getIconClass(selectedObject)
  const selectionName = selectedObject?.GA
    ? selectedObject?.sectionName
    : `Sec ${selectedObject.sectionNumber} • Row ${selectedObject.rowNumber}`
  const selectionDescription =
    selectedObject.offer?.description ||
    selectedObject?.listing?.offer?.description

  const mapSeat = selectedObject?.seatId
    ? seatmapData?.seats?.[selectedObject.seatId]
    : null
  const accessibleType =
    mapSeat?.accessibleType ||
    mapSeat?.accessiblityType ||
    mapSeat?.accessibilityType ||
    selectedObject?.accessibleType ||
    selectedObject?.accessiblityType ||
    selectedObject?.accessibilityType
  const isAccessible =
    Boolean(accessibleType) ||
    Boolean(mapSeat?.accessible || selectedObject?.accessible)
  const accessibleLabel = isAccessible
    ? getAccessibleLabel(accessibleType)
    : null
  const additionalLabel = getSeatAdditionalLabel({
    mapSeat,
    ticketGroup: selectedObject,
    seatLabels: seatmapData?.seatLabels,
  })

  const { slug } = useParams()

  return (
    <div className="vjx-td">
      <SheetTop canGoBack={true} goBack={toggleView} />
      <ViewSwiper
        viewingSectionId={selectedObject?.sectionId}
        sectionNumber={selectedObject?.sectionNumber.toLowerCase()}
        smallButtons={true}
        slug={slug}
      />
      <div className={`vjx-tdd ${iconClass}`}>
        <span className="vjx-tdd-s">{selectionName}</span>
        {accessibleLabel && (
          <span className="vjx-tdd-sub">{accessibleLabel}</span>
        )}
        {additionalLabel && (
          <span className="vjx-tdd-sub">{additionalLabel}</span>
        )}
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          paddingTop: '16px',
        }}
      >
        {allowTicketCountChange && (
          <TicketCountChange
            selectedObject={selectedObject}
            changeQuickpickQuantity={changeQuickpickQuantity}
            eventTicketLimit={eventTicketLimit}
            quantity={selectedObject?.quantity}
            isOfferDiscount={false}
          />
        )}
      </div>
      {selectionDescription && (
        <div className="vjx-td-desc">
          <span className="vjx-td-desc-1">Ticket description</span>
          <pre className="vjx-td-desc-2">{selectionDescription}</pre>
        </div>
      )}
    </div>
  )
}

// This is intended to be only used with quickpicks
function TicketCountChange({
  selectedObject,
  changeQuickpickQuantity,
  eventTicketLimit,
  quantity,
}) {
  const selectionPrice = selectedObject?.price
  const isResale = Boolean(
    selectedObject?.resale || selectedObject?.listing?.id
  )
  const selectionType = selectedObject?.name || (isResale ? 'Resale' : '')
  const availableCount = selectedObject.GA
    ? selectedObject.availableCount
    : selectedObject.seatIds.length
  const listingQuantity =
    Number(selectedObject?.listing?.quantity) || availableCount

  const options = isResale
    ? [listingQuantity]
    : getValidQuantitiesForTicketGroup(
        selectedObject.offer,
        availableCount,
        eventTicketLimit
      )

  return (
    <div className="vjx-tcc">
      <div className="d-flex flex-column">
        <span className="vjx-tcc-span">{selectionType}</span>
        <p className="vjx-tcc-p">
          {formatOfferListPrice(selectionPrice, selectedObject.offer)} ea{' '}
          <span className="vjx-tcc-p-span">
            {selectedObject.offer?.freeOffer
              ? 'complimentary'
              : 'incl. taxes & fees'}
          </span>
        </p>
      </div>
      <Form.Select
        value={quantity}
        onChange={(e) => changeQuickpickQuantity(e.target.value)}
        aria-label="Default select example"
        disabled={isResale}
      >
        {options.map((number) => (
          <option key={number} value={number}>
            {number} {getSinglarOrPluralWord(number)}
          </option>
        ))}
      </Form.Select>
    </div>
  )
}

{
  /* <Form.Select
                  value={quickpickQuantity}
                  onChange={(e) => changeQuickpickQuantity(e.target.value)}
                  aria-label='Default select example'
              >
                  {options.map((number) => (
                      <option key={number} value={number}>
                          {number} {getSinglarOrPluralWord(number)}
                      </option>
                  ))}
              </Form.Select> */
}
